import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import type DiabguideRecommendationStartedJournalEvent from "parog-web/models/diabguide-recommendation-started-journal-event";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";
import type DiabguideRecommendation from "./diabguide-recommendation";

//---- Automatically generated, don't update this part ----

/**
 * This JE is created by Diabguide. It's contains all recommendations for the patient
 */
export default class DiabguideRecommendationComputedJournalEvent extends JournalEvent {
  static override type = "diabguide-recommendation-computed-journal-event";

  @attr() declare warning: string[];

  @belongsTo("diabguide-recommendation-started-journal-event", {
    async: false,
    inverse: "diabguideRecommendationComputedJournalEvent"
  })
  declare diabguideRecommendationStartedJournalEvent: DiabguideRecommendationStartedJournalEvent;

  static override validations(intl: IntlService) {
    return {
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.diabguide-recommendation-computed-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----
  @attr("diabguide-recommendation") declare data: DiabguideRecommendation;

  @belongsTo("patient", {
    async: false,
    inverse: "diabguideRecommendationComputedJournalEvents"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "diabguide-recommendation-computed-journal-event": DiabguideRecommendationComputedJournalEvent;
  }
}
